import React from "react"
import NextRouteCard from "./nextroutecard"
import * as styles from "../../styles/nextroutesection.module.scss"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faMapMarkedAlt } from "@fortawesome/free-solid-svg-icons"
import FeatureHubCard from "./featurehubcard"

const NextRouteSection = ({ routes }) => {
  if (!routes || routes.length === 0) return null

  return (
    <div className={styles.sectionWrapper}>
      <h2 className={styles.label}>
        <FontAwesomeIcon icon={faMapMarkedAlt} className={styles.mapIcon} />
        次にどこ行く？
      </h2>
      {routes.map((route, index) => (
        <NextRouteCard
          key={route.slug}
          {...route}
          isSlim={index > 0} // 0番目以外は true になる
        />
      ))}
      <FeatureHubCard area={routes[0].area} />
    </div>
  )
}

export default NextRouteSection
